
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Der R0-Wert ist eine der wichtigsten Kennziffern bei der Seuchenbekämpfung,
  weil er den Behörden Informationen liefert, wie sie auf den Ausbruch eines
  Virus reagieren sollen. Ist er höher als 1, verbreitet sich eine Infektion
  weiter, ist er kleiner als 1, verschwindet die Krankheit langsam. Da der Wert
  beim neuen Coronavirus grösser ist, breitet es sich momentan weltweit aus.
  Inzwischen haben schon mehr als hundert Länder Fälle gemeldet.
    </p>
    <p>
  Wichtig zu wissen ist: Der R0-Wert beschreibt die potenzielle
  Ansteckungsgefahr. Wie viele Menschen sich tatsächlich anstecken, ist von den
  Umständen abhängig und kann von Region zu Region unterschiedlich sein. Deshalb
  wird der Wert meist mit einer Spannweite angegeben. Es ist entscheidend, wie
  eng Menschen zusammenleben, wie anfällig eine Bevölkerungsgruppe auf eine
  bestimmte Krankheit ist und wie gut das Gesundheitssystem funktioniert.
    </p>
    <p>
  So ist Sars-CoV-2 potenziell ansteckender als Influenza, das die saisonale
  Grippe verursacht. Am neuen Coronavirus sind aber bislang gut 114’000 Menschen
  erkrankt, während es bei der Grippe jährlich Millionen sind. Das ist nur
  möglich, weil die Behörden schnell reagiert haben, etwa mit Quarantänen und
  Kontrollen an Flughäfen. Bei der normalen Grippe werden weniger Massnahmen
  getroffen, sie hat sich inzwischen auf der ganzen Welt festgesetzt – was man
  bei Sars-CoV-2 genau verhindern will.
    </p>
    <div className='zitat'>
  «Ich weiss von keinem Ausbruch in den letzten 100 Jahren, der sich so schnell
  so weit ausgebreitet hat.»
  <div className='source'>Jeremy Farrar, Infektionsmediziner</div>
    </div>
    <p>
  Eindämmen konnte man das Virus bisher aber nicht – im Gegenteil: «Was wir
  gerade sehen, ist beispiellos. Ich weiss von keinem Ausbruch in den letzten
  100 Jahren, der sich so schnell so weit ausgebreitet hat», sagte der bekannte
  britische Infektionsmediziner Jeremy Farrar. Die grösste Sorge der WHO ist,
  dass das Virus in Länder mit schwächerem Gesundheitssystem gelangt, die nicht
  die Kapazitäten zur Eindämmung einer Epidemie haben.
    </p>
    <p>
  Immerhin scheint Sars-CoV-2 die Menschen nicht ganz so krank zu machen wie
  Sars, bei dem es sich ebenfalls um ein Coronavirus handelte und das vor 17
  Jahren bei fast 10 Prozent der Betroffenen tödlich verlief. Wegen Sars-CoV-2
  sind bisher gut 4000 Menschen gestorben, das entspricht 3,5 Prozent der
  bestätigten Fälle von Infizierten. Zum Vergleich: Bei Influenza beträgt die
  Sterberate je nach Region und Saison 0,02 bis 0,3 Prozent.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;